export default __webpack_public_path__ + "static/media/Frame_187.5d47d349.jpg";